import type { FaireProductEntity } from "../../entity_types/product";

export const p_m7zgp3q3yp: FaireProductEntity = {
  token: "p_m7zgp3q3yp",
  type: "product",
  name: "Sticker Pack",
  brandName: "Schorrline Design",
  imageUrl:
    "https://cdn.faire.com/fastly/0934f4cc4a16a748b8b1784068983887ea8465f19ed60ee06e4d319d5b87ce5a.jpeg",
  priceDollars: 8,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/62be8f7b5b446981f396269cd62bbfbe2616236514e9086dc77e03fdb77217ca.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
